
const ZS = process.env.NODE_ENV === 'production' && process.env.VUE_APP_MODE === undefined;
export default {
    universal: {
      host:   ZS ? "hsj5m.hulian120.com/download.html" : "hsjh5dev.hulian120.com/m/download.html",
      pathKey: "action"
    },
    scheme: {
      protocol: "hulian120NurseFuel://"
    },
    outChain: {
      protocol: "ykshortvideo",
      path: "temporary",
      key: "url"
    },
    intent: {
      package: "myapp://hsjapp",
      scheme: "hulian120NurseFuel://"
    },
    appstore: "https://itunes.apple.com/cn/app/id976899984",
    yingyongbao:
      "//a.app.qq.com/o/simple.jsp?pkgname=com.jkhh.nurse&from=groupmessage",
    fallback:
      "https://a.app.qq.com/o/simple.jsp?pkgname=com.jkhh.nurse&from=groupmessage",
    timeout: 2000
};
